import { getCookie } from './cookies.js';

const signupForm = document.querySelector('#add-ensemble-form');

if (signupForm) {
  let started = false;

  signupForm.addEventListener('input', () => {
    if (window.umami && !started) {
      umami.track('signup-form-started');
      started = true;
    }
  });
}
window.addEventListener("load", () => {
  const el = document.getElementById("analytics-events");
  if (!el || !window.umami) return;

  let events;

  try {
    events = JSON.parse(el.dataset.events || "[]");
  } catch {
    return;
  }

  if (!events.length) return;

  events.forEach(e => {
    if (e?.name) umami.track(e.name, e.data || {});
  });

  const configEl = document.getElementById('js-config');
  const consumeUrl = configEl.dataset.consumeAnalyticsEventsUrl;

  fetch(consumeUrl, {
      method: 'POST',
      headers: {
        'X-CSRFToken': getCookie('csrftoken'),
      },
      credentials: 'same-origin'
  });

});